import { ISelectedOnMapSitesByVendor } from '@interfaces/kpi/kpiCommon';

import { EVendorsValues } from '@enums/common';

export const defaultSelectedSitesOnMap: Array<ISelectedOnMapSitesByVendor> = [
	{
		vendor: EVendorsValues.limenet,
		sites: [],
	},
	{
		vendor: EVendorsValues.nokia,
		sites: [],
	},
];
